const MONTH_INDEX = 0;
const MIN_AGE = 0;

export const LEGAL_AGE = 18;

const getAgeUtil = (birthDateString: string, compareDateString?: string) => {
  const compareDate = compareDateString ? new Date(compareDateString) : new Date();
  const birthDate = new Date(birthDateString);
  let age = compareDate.getFullYear() - birthDate.getFullYear();
  const m = compareDate.getMonth() - birthDate.getMonth();
  if (m < MONTH_INDEX || (m === MONTH_INDEX && compareDate.getDate() < birthDate.getDate())) {
    age--;
  }

  return age < MIN_AGE ? NaN : age;
};

export default getAgeUtil;
